import CopilotService from './copilot.service';

// export function createCopilotService() {
//   const apiUrlProd = 'https://api-agents.organia.ai/';
//   const apiUrlHml = 'https://hml-agents-api.organia.ai/';
//   const locale = document.location.hostname.includes('develop') ? apiUrlHml : apiUrlProd;
//   const apiUrl = locale || apiUrlHml;
//   const isDev = !!import.meta.env.DEV;
//   return new CopilotService(apiUrl, isDev);
// } 

export function createCopilotService() {
  const apiUrlProd = 'https://api-agents.organia.ai/';
  const apiUrlHml = 'https://hml-agents-api.organia.ai/';
  const hostname = document.location.hostname || '';
  const isDevRuntime = !!import.meta.env.DEV;
  const isLocalHost = hostname.includes('localhost') || hostname.includes('127.0.0.1');
  const isDevelopHost = hostname.includes('develop') || hostname.includes('dev');
  const useHml = isDevRuntime || isLocalHost || isDevelopHost;
  const apiUrl = useHml ? apiUrlHml : apiUrlProd;
  return new CopilotService(apiUrl, isDevRuntime);
} 